<pa-button *ngIf="(context | async).is_folderish" icon="add" traverseTo="./@@add"></pa-button>
<pa-button color="secondary" icon="pen" traverseTo="./@@edit"></pa-button>
<pa-button color="destructive" icon="delete" (click)="delete()"></pa-button>